import styled from 'styled-components';

export const StyledMap = styled.div`
	display: flex;
	flex-direction: column;
	height: calc(100vh - 72px);
	width: 100%;

	@keyframes drop-target-march {
		from { stroke-dashoffset: 0; }
		to   { stroke-dashoffset: -36; }
	}

	.course-map {
		&.dragging {
			cursor: all-scroll;
		}
	}

	.link {
		fill: none;
		stroke-width: 2px;
	}

	text {
		pointer-events: none;
	}

	.empty-icon {
		fill: none;
		stroke: none;
		pointer-events: none;
	}

	.empty-icon + path + path {
		display: none;
	}

	.map-merge-icon {
		fill: #737295;
		stroke: #737295;
	}

	.map-plus-icon,
	.map-minus-icon,
	.map-merge-icon {
		cursor: pointer;
	}

	.map-plus-icon {
		fill: var(--green-500);
		stroke: var(--c-white);
		stroke-width: 3px;
	}

	.map-minus-icon {
		fill: var(--red-500);
		stroke: var(--c-white);
		stroke-width: 3px;
	}

	.active-icon {
		animation: pulse 1s infinite;
	}

	@keyframes pulse {
		0% {
			fill: var(--green-500);
			stroke: var(--green-500);
			stroke-width: 0;
		}
		50% {
			fill: var(--green-400);
			stroke: var(--green-400);
			stroke-width: 7px;
		}
		100% {
			fill: var(--green-500);
			stroke: var(--green-500);
			stroke-width: 0;
		}
	}

	.base-node-icon {
		display: none;
		pointer-events: none;
	}

	.new-rect {
		fill: var(--org-color);
		stroke: var(--org-color);
	}

	rect {
		transition: fill 0.3s, stroke 0.3s;
	}

	.new-rect + text {
		fill: var(--neutral-50);
	}

	@keyframes dashoffset-animation {
		to {
			stroke-dashoffset: 1000;
		}
	}

	.course-backdrop {
		opacity: 0;
		stroke-dasharray: 50;
		stroke-width: 3px;
		stroke: var(--org-color);
		transition: opacity 0.3s;
	}

	.active-node {
		animation: dashoffset-animation 4s infinite linear;
		opacity: 1;
	}

	.discipline-card {
		cursor: pointer;
	}

	.view-button {
		cursor: pointer;

		.panel & {
			opacity: 0.3;
			cursor: none;
			pointer-events: none;
		}
	}

	.view-button-text {
		.panel & {
			cursor: none;
			pointer-events: none;
		}
	}
`;

export const StyledMapToolbar = styled.div`
	align-items: center;
	background-color: var(--panel-color);
	border-bottom: 1px solid rgba(0, 0, 0, 0.08);
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
	display: flex;
	flex-shrink: 0;
	height: 52px;
	justify-content: space-between;
	padding: 0 var(--spacing-4);
	width: 100%;
	z-index: 10;
	position: relative;
`;

export const StyledUnsavedButton = styled.button`
	align-items: center;
	background-color: var(--warning-bg-color, rgba(251, 191, 36, 0.15));
	border: 1px solid rgba(146, 64, 14, 0.2);
	border-radius: 6px;
	color: var(--warning-text-color, #92400e);
	cursor: pointer;
	display: flex;
	font-size: 13px;
	font-weight: 500;
	gap: 6px;
	padding: 5px 12px;
	transition: background 0.15s ease, border-color 0.15s ease;

	span {
		text-decoration: underline;
		text-decoration-style: dashed;
		text-underline-offset: 3px;
		text-decoration-color: rgba(146, 64, 14, 0.4);
	}

	&:hover {
		background-color: rgba(251, 191, 36, 0.28);
		border-color: rgba(146, 64, 14, 0.4);
	}
`;
